export const tryParseBoolean = (str) => {
    if (typeof str !== "string") return str;

    const lower = str.toLowerCase();
    if (lower === "true") return true;
    if (lower === "false") return false;

    return null;
};



// WEBPACK FOOTER //
// ./src/components/common/Helpers/BooleanHelper.js